import './CircleSvgSpinner.scss';

import React from 'react';

const CircleSvgSpinner = (props: { open: boolean }) => {
  return props.open ? (
    <svg height="300" width="300" xmlns="http://www.w3.org/2000/svg">
      <circle
        className="circle"
        cx="150"
        cy="150"
        fill="none"
        id="arc1"
        opacity=".89"
        paintOrder="fill markers stroke"
        r="120"
        stroke="#632b26"
        strokeLinecap="square"
        strokeOpacity=".99213"
        strokeWidth="12"
      />
      <circle
        className="circle"
        cx="150"
        cy="150"
        fill="none"
        id="arc2"
        opacity=".49"
        paintOrder="fill markers stroke"
        r="120"
        stroke="#632b26"
        strokeLinecap="square"
        strokeOpacity=".99213"
        strokeWidth="8"
      />
      <circle
        className="circle"
        cx="150"
        cy="150"
        fill="none"
        id="arc3"
        opacity=".49"
        paintOrder="fill markers stroke"
        r="100"
        stroke="#632b26"
        strokeLinecap="square"
        strokeOpacity=".99213"
        strokeWidth="20"
      />
      <circle
        className="circle"
        cx="150"
        cy="150"
        fill="none"
        id="arc4"
        opacity=".49"
        paintOrder="fill markers stroke"
        r="120"
        stroke="#632b26"
        strokeLinecap="square"
        strokeOpacity=".99213"
        strokeWidth="30"
      />
      <circle
        className="circle"
        cx="150"
        cy="150"
        fill="none"
        id="arc5"
        opacity=".89"
        paintOrder="fill markers stroke"
        r="100"
        stroke="#632b26"
        strokeLinecap="square"
        strokeOpacity=".99213"
        strokeWidth="8"
      />
      <circle
        className="circle"
        cx="150"
        cy="150"
        fill="none"
        id="arc6"
        opacity=".49"
        paintOrder="fill markers stroke"
        r="90"
        stroke="#632b26"
        strokeLinecap="square"
        strokeOpacity=".99213"
        strokeWidth="16"
      />
      <circle
        className="circle"
        cx="150"
        cy="150"
        fill="none"
        id="arc7"
        opacity=".89"
        paintOrder="fill markers stroke"
        r="90"
        stroke="#632b26"
        strokeLinecap="square"
        strokeOpacity=".99213"
        strokeWidth="8"
      />
      <circle
        className="circle"
        cx="150"
        cy="150"
        fill="#4DD0E1"
        fillOpacity="0"
        id="arc8"
        opacity=".79"
        paintOrder="fill markers stroke"
        r="80"
        stroke="#632b26"
        strokeLinecap="square"
        strokeOpacity=".99213"
        strokeWidth="8"
      />
    </svg>
  ) : null;
};

export default CircleSvgSpinner;
